import { Box, Skeleton, Typography } from '@mui/material';
import { FC } from 'react';
import { StyledHead } from './styled';
export * from './tabHead';

type WithActions = {
  showActions: true;
  renderActions: () => JSX.Element;
};
export type Actions = WithActions | { showActions: false };

type Props = {
  headline?: string;
  subtitle?: string;
  renderBeforeHeadline?: () => JSX.Element;
  renderAfterHeadline?: () => JSX.Element;
  showSkeleton?: boolean;
  small?: boolean;
} & Actions;

/**
 *  ContentHead should be used to headline the content part of a certain page, for example PageWithMenu.
 *
 */
export const ContentHead: FC<Props> = ({
  headline,
  subtitle,
  renderBeforeHeadline,
  renderAfterHeadline,
  showSkeleton = false,
  small = false,
  ...actionProps
}) => {
  return (
    <StyledHead small={small}>
      <Box display="flex" gap="16px" alignItems="center" flexGrow={1}>
        {renderBeforeHeadline?.()}
        {renderHeadline(headline, subtitle, showSkeleton)}
        {renderAfterHeadline?.()}
      </Box>
      {actionProps.showActions ? actionProps.renderActions() : <div />}
    </StyledHead>
  );
};

const renderHeadline = (
  headline: string | undefined,
  subtitle: string | undefined,
  showSkeleton: boolean
): JSX.Element | null => {
  if (showSkeleton) {
    return <Skeleton variant="text" width="160px" height="32px" />;
  }

  if (headline) {
    if (subtitle) {
      return (
        <Box className="p-0">
          <Typography variant="h3">{headline}</Typography>
          <Typography variant="body2" color="grey.600">
            {subtitle}
          </Typography>
        </Box>
      );
    } else {
      return <Typography variant="h3">{headline}</Typography>;
    }
  }

  return null;
};
